<template>
  <div class="input-group">
    <label
      v-if="label"
      :for="id"
      :class="[error ? labelError : labelValid]"
      class="block w-full cursor-pointer text-sm pl-1"
    >{{ label }}</label>
    <label
      class="inline-block border border-grey-9 text-sm bg-grey-1 px-2 py-1 rounded hover:bg-grey-2 text-blue-8 hover:text-blue-7 hover:border-blue-7 cursor-pointer transition-colors transition-250"
      :class="[error ? inputError : inputValid]"
    >
      <span class="inline-block mx-1">
        <upload-icon class="inline-block" style="margin-top: -0.2rem;"></upload-icon>
      </span>
      <slot>
        <span class="mr-1">{{ fileName ? fileName : 'Select a file' }}</span>
      </slot>
      <input type="file" class="hidden" :accept="accept" :id="id" @input="input" ref="input" />
    </label>
    <p v-if="info && !error" class="text-sm text-blue-8 mt-1 pl-1">{{ info }}</p>
    <p v-if="error" class="text-sm text-red-8 mt-1 pl-1">{{ error }}</p>
  </div>
</template>

<script>
import { UploadIcon } from "vue-feather-icons"

export default {
  name: "FileInput",
  components: {
    UploadIcon
  },
  props: {
    id: {
      required: true
    },
    errors: {
      default: null
    },
    label: {
      default: null
    },
    accept: {
      default: null
    },
    info: {
      default: null
    }
  },
  data() {
    return {
      labelValid: "text-blue-8",
      labelError: "text-red-8",
      inputValid: "border-grey-5 hover:border-blue-7 focus:border-blue-9",
      inputError:
        "border-red-5 text-red-8 hover:border-red-7 focus:border-red-9",
      fileName: null
    }
  },
  computed: {
    error() {
      if (!this.errors) return false
      return this.errors.has(this.id) ? this.errors.first(this.id) : false
    }
  },
  methods: {
    input(e) {
      if (this.errors) this.errors.clear(this.id)

      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.fileName = null
        return
      }

      let file = files[0]
      this.fileName = file.name
      this.$emit("input", file)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
